// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fFsO","colBig":"styles_colBig__3HLCl","colSmall":"styles_colSmall__1W1Bx","shopifyNameWrapper":"styles_shopifyNameWrapper__1ZRtu"};